const investmentKpiLang = {
	global_net_irr: {
		tag: 'investment.kpi.global_net_irr',
		fr: 'TRI net global',
		en: 'Global Net IRR',
	},
	ns_value: {
		tag: 'investment.kpi.ns_value',
		fr: 'n.s.',
		en: 'n.s.',
	},
	total_value_to_paid_in: {
		tag: 'investment.kpi.total_value_to_paid_in',
		fr: "TVPI (Total Value to Paid In): Ratio entre la valeur liquidative à date additionnée à l'ensemble des distributions effectuées à date et le montant des capitaux appelés à date",
		en: 'Total Value to Paid In (TVPI): The ratio of the current value of remaining investments within a fund, plus the total value of all distributions to date, relative to the total amount of capital paid into the fund to date.',
	},
	total_value: {
		tag: 'investment.kpi.total_value',
		fr: 'Valeur totale',
		en: 'Total value',
	},
	total_value_tooltip: {
		tag: 'investment.kpi.total_value_tooltip',
		fr: 'Valeur totale : Somme de la VL (Valeur Liquidative) des parts de l’investisseur et des distributions déjà réalisées à date',
		en: 'Total Value: The sum of the fund NAV and all distributions (amortization and interest)',
	},
	total_committed_capital: {
		tag: 'investment.kpi.total_committed_capital',
		fr: 'Capital engagé total',
		en: 'Total committed capital',
	},
	capital_called: {
		tag: 'investment.kpi.capital_called',
		fr: 'Capital appelé',
		en: 'Called capital',
	},
	committed_capital: {
		tag: 'investment.kpi.committed_capital',
		fr: 'Capital engagé',
		en: 'Committed capital',
	},
	fund_commitments: {
		tag: 'investment.kpi.fund_commitments',
		fr: 'Engagements du fonds',
		en: 'Fund commitments',
	},
	called_capital: {
		tag: 'investment.kpi.called_capital',
		fr: 'Capital appelé',
		en: 'Called capital',
	},
	contributed_capital: {
		tag: 'investment.kpi.contributed_capital',
		fr: 'Montant investi',
		en: 'Contributed capital',
	},
	callable_capital: {
		tag: 'investment.kpi.callable_capital',
		fr: 'Reste à appeler',
		en: 'Uncalled capital',
	},
	callable_capital_tooltip: {
		tag: 'investment.kpi.callable_capital_tooltip',
		fr: 'Reste à appeler: Capital non appelé et que le fonds peut encore appelé',
		en: 'Uncalled capital (Callable capital): Portion of the capital not yet paid by an investor and for which the fund can still demand payment',
	},
	outstanding_capital: {
		tag: 'investment.kpi.outstanding_capital',
		fr: 'Capital restant dû',
		en: 'Asset Outstanding capital',
	},
	net_called_capital: {
		tag: 'investment.kpi.net_called_capital',
		fr: 'Capital net',
		en: 'Capital at work',
	},
	net_called_capital_tooltip: {
		tag: 'investment.kpi.net_called_capital_tooltip',
		fr: 'Capital net = Capital appelé moins les amortissements distribués',
		en: 'Capital at work = Called capital minus distributed return of capital',
	},
	net_called_capital_minus_roc: {
		tag: 'investment.kpi.net_called_capital_minus_roc',
		fr: 'moins RoC',
		en: 'minus RoC',
	},
	unrealized_capital_gain: {
		tag: 'investment.kpi.unrealized_capital_gain',
		fr: 'Gain non réalisé de capital',
		en: 'Unrealized capital gain',
	},
	distributed_interest_income: {
		tag: 'investment.kpi.distributed_interest_income',
		fr: 'Intérêts distribués',
		en: 'Distributed interest income',
	},
	distributions: {
		tag: 'investment.kpi.distributions',
		fr: 'Distributions',
		en: 'Distributions',
	},
	distributed_return_of_capital: {
		tag: 'investment.kpi.distributed_return_of_capital',
		fr: 'Amortissements distribués',
		en: 'Distributed return of capital',
	},
	net_asset_value: {
		tag: 'investment.kpi.net_asset_value',
		fr: "Valeur d'actif net",
		en: 'Net Asset Value',
	},
	nav: {
		tag: 'investment.kpi.nav',
		fr: 'NAV',
		en: 'NAV',
	},
	including_recallable: {
		tag: 'investment.kpi.including_recallable',
		fr: 'Dont rappelable',
		en: 'Including recallable',
	},

	arr: {
		tag: 'investment.kpi.arr',
		fr: 'ARR',
		en: 'ARR',
	},
	arr_tooltip: {
		tag: 'investment.kpi.arr_tooltip',
		fr: '(Annualized Rate of Return): rendement annuel moyen sur l’ensemble de la période d’investissement. Formule:  ( (total des distributions à date + VL) / (Total des appels à date) ) ^ (1 / durée d’investissement en année) -1​',
		en: '(Annualized Rate of Return): Compound average annual return an investor receives over the investment period. Formula used:  ( (Cumulated distribution + NAV) / (Cumulated capital calls) ) ^ (1 / Number of years) -1​',
	},
	irr: {
		tag: 'investment.kpi.irr',
		fr: 'TRI',
		en: 'IRR',
	},
	moic: {
		tag: 'investment.kpi.moic',
		fr: 'MOIC',
		en: 'MOIC',
	},
	tvpi: {
		tag: 'investment.kpi.tvpi',
		fr: 'TVPI',
		en: 'TVPI',
	},
	tvpi_tooltip: {
		tag: 'investment.kpi.tvpi_tooltip',
		fr: 'TVPI : “Total Value to Paid-In Capital”. Somme de la VL (Valeur Liquidative) des parts de l’investisseur et des distributions déjà réalisés à date divisé par le capital appelé total',
		en: 'TVPI: Total Value to Paid-In Capital. The sum of the fund NAV and all distributions (amortization and interest) done at date divided by the total capital called',
	},
	dpi: {
		tag: 'investment.kpi.dpi',
		fr: 'DPI',
		en: 'DPI',
	},
	rvpi: {
		tag: 'investment.kpi.rvpi',
		fr: 'RVPI',
		en: 'RVPI',
	},
	vintage: {
		tag: 'investment.kpi.vintage',
		fr: 'Millésime',
		en: 'Vintage',
	},
	sfdr: {
		tag: 'investment.kpi.sfdr',
		fr: 'SFDR',
		en: 'SFDR',
	},
	domain: {
		tag: 'investment.kpi.domain',
		fr: 'Domaine',
		en: 'Domain',
	},
};

export default investmentKpiLang;
